/**
 * Export Data Service
 * Handles exporting data from Cosmic Frog to Excel sheets
 */

/**
 * Parse CSV string into 2D array
 * @param {string} csvString - CSV content
 * @returns {Array<Array<string>>} 2D array of data
 */
function parseCSV(csvString) {
    const lines = csvString.trim().split('\n');
    const result = [];

    for (const line of lines) {
        const row = [];
        let currentCell = '';
        let inQuotes = false;

        for (let i = 0; i < line.length; i++) {
            const char = line[i];

            if (char === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    // Escaped quote
                    currentCell += '"';
                    i++; // Skip next quote
                } else {
                    // Toggle quote state
                    inQuotes = !inQuotes;
                }
            } else if (char === ',' && !inQuotes) {
                // End of cell
                row.push(currentCell);
                currentCell = '';
            } else {
                currentCell += char;
            }
        }

        // Push last cell
        row.push(currentCell);
        result.push(row);
    }

    return result;
}

/**
 * Import CSV data into an Excel sheet
 * @param {string} csvContent - CSV file content
 * @param {string} sheetName - Target sheet name
 * @returns {Promise<void>}
 */
export async function importCSVToSheet(csvContent, sheetName) {
    return await window.Excel.run(async (context) => {
        const workbook = context.workbook;

        // Parse CSV
        const data = parseCSV(csvContent);

        if (data.length === 0) {
            throw new Error('CSV file is empty');
        }

        // Get or create sheet
        let sheet = workbook.worksheets.getItemOrNullObject(sheetName);
        await context.sync();

        console.log(`save to sheet ${sheetName}`);

        if (sheet.isNullObject) {
            // Sheet doesn't exist, create it
            sheet = workbook.worksheets.add(sheetName);
        } else {
            // Sheet exists, clear it
            const usedRange = sheet.getUsedRange();
            usedRange.clear();
        }
        console.log('writing data');
        // Write data to sheet starting at A1
        const range = sheet.getRangeByIndexes(0, 0, data.length, data[0].length);
        range.values = data;

        // Auto-fit columns
        range.format.autofitColumns();

        await context.sync();
    });
}
